import {DeviceChooser} from './DeviceChooser';

export default DeviceChooser;
